export default "__VITE_ASSET__CX7N3tW6__"